import React from 'react';
import PropTypes from 'prop-types';
import { Button, notification } from 'antd';
import {
  ReloadOutlined,
} from '@ant-design/icons';

export default class UpdateAvailableAlert extends React.Component {

  static propTypes = {
    updateAvailable: PropTypes.bool.isRequired,
  };

  componentDidUpdate(prevProps) {
    if ( !prevProps.updateAvailable && this.props.updateAvailable) { // Error -> Ok transition
      notification.open({
        message: 'New Version Available',
        description: "Updates include new features, bug fixes and stability improvements. Please update to use the latest version.",
        btn: (<Button type="primary" onClick={() => window.location.reload()} >Update now</Button>),
        icon: <ReloadOutlined />,
        duration: 0,
        closeIcon: null,
      });
    }
  }

  render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./scripts/components/UpdateAvailableAlert.jsx